import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import axios from 'axios';



import './MarketingAnalysis.scss';
import MyContext from '../MyContext.jsx';
var customer_XHR={'abort' : ()=>{}};
const options = [
  { value: 'Select', label: 'Select' },
  { value: 'ISI', label: 'ISI' },
  { value: 'Non ISI', label: 'Non ISI' },

]

class MarketingAnalysis extends Component {


    constructor(props) {
      super(props);

      this.dealerSelect = React.createRef();
      this.categorySelect = React.createRef();
      this.brandSelect = React.createRef();
      this.contactSelect = React.createRef();


      this.state = {
        analysis : 'COMPETITOR ANALYSIS',
        dealers : [],
        dealer  : '',
        categories : [],
        category  : '',
        brands : [],
        brand : '',
        products : [],
        reason : '',
        contacts : [],
        contact : '',
        other_brands : '',
        remarks : '',
        sid :'',
      }
      this.formChange = this.formChange.bind(this);
    }

    componentDidMount(){  
      var obj_this = this;
      //get categories and brands
      const url1 = `${process.env.REACT_APP_SSS}/api/get/marketing/analysis/details`;

      $.ajax({
        url : url1,
        data : {
          sid : this.context.user_details.sid
        },
        type : "GET"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          obj_this.setState({
            dealers : return_data.dealers,
            categories : return_data.categories,
            types : return_data.types,
            contacts : return_data.contacts,
          });
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }

    formChange(e){
      this.setState({
        [e.target.name] : e.target.value
      });
    }

    analysisChange(e){
      // console.log(option);
      this.setState({
        analysis : e.target.value
      }); 
    }
    dealerChange(option){
      this.setState({
        dealer : option
      });
    }

    contactChange(option){
      this.setState({
        contact : option
      });
    }

    categoryChange(option){
     
      this.setState({
        category : option
      });
      this.context.loading(1);
      const obj_this = this;
      const url = `${process.env.REACT_APP_SSS}/api/get/brands`;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,

          category_id : option
        },
        type : "GET"
      }).done(function(return_data){
            console.log(return_data);
        if(return_data.status == "success"){
          obj_this.setState({
            brands : return_data.brands,
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }

    brandChange(option){
      this.setState({
        brand : option
      });
      this.context.loading(1);
      const obj_this = this;
      const url = `${process.env.REACT_APP_SSS}/api/get/products`;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,
          brand_id : option.value,
        },
        type : "GET"
      }).done(function(return_data){
            console.log(return_data);
        if(return_data.status == "success"){
          obj_this.setState({
            products : return_data.products,
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });

    }

    formSubmit(e){
      e.preventDefault();
      const salesorder = this.state;
      
      console.log(salesorder);
     
      var type = null;
      e.preventDefault();
      var details = this.state;
      if(details.analysis == "COMPETITOR ANALYSIS"){
        type = 1;
      if(!details.dealer.value){
        this.dealerSelect.current.focus();
        return;
      }
      if(!details.category.value){
        this.categorySelect.current.focus();
        return;
      }
      if(!details.brand.value){
        this.brandSelect.current.focus();
        return;
      }
    }
    else {
      type = 2;
      if(!details.dealer.value){
        this.dealerSelect.current.focus();
        return;
      }
      if(!details.contact.value){
        this.contactSelect.current.focus();
        return;
      }
    }
      var sid =  this.context.user_details.sid;
      console.log(this.fileArray);   
      var obj_this = this;
      var fd = new FormData(document.querySelector('form'));
      fd.append('type',type);


      fd.append('sid',sid);

      const url = `${process.env.REACT_APP_SSS}/api/save/marketing/analysis/details`;

      axios.post(url,fd)
      .then(res =>{
        console.log(res.data);
        if(res.data.status == "success"){
          alert("Marketing analysis inserted successfully.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else {
          alert("Network Error.");
          obj_this.context.loading(0);
        }
      });
    }    

  render(){

  return (

    <MyContext.Consumer>
      {context => (
        <div className="new_marketing_analysis_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> MARKETING ACTIVITY</div>
          </div> 
          <form className="dealer_form"
            onSubmit={e => this.formSubmit(e)} encType="multipart/form-data" 
          >
            <div className="product_details_container blocks">

            <div className="input_radio_container">
                    <div className="lead_type_radio_buttons">
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="analysis" 
                          value="COMPETITOR ANALYSIS"  
                          checked={this.state.analysis == 'COMPETITOR ANALYSIS'} 
                          onChange={e => this.analysisChange(e)}
                        />
                        <div>Competitor Analysis</div>
                      </div>
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="analysis" 
                          value="OTHERS"
                          checked={this.state.analysis == 'OTHERS'} 
                          onChange={e => this.analysisChange(e)}
                        />
                        <div>Others</div>
                      </div>
                    </div>
                </div>
                <div className="input_label">Dealer *</div>
                  <Select 
                    options={this.state.dealers}  
                    value ={this.state.dealer}
                    name = "dealer"
                    className="district" 
                    ref={this.dealerSelect}
                    onChange={e => this.dealerChange(e)}
                    required
                  />  
              
            </div>
            

            <div className="product_details_container blocks" style={{display:this.state.analysis == 'COMPETITOR ANALYSIS'?"block":"none"}}>
            <div className="customer_container">
              <div className="input_label_head">Competitor Analysis</div> 
            </div>
            <div className="input_label">Categories *</div>
                  <Select 
                    options={this.state.categories}  
                    value ={this.state.category}
                    name = "category"
                    className="district" 
                    ref={this.categorySelect}
                    onChange={e => this.categoryChange(e)}
                    required
                  />   
                <div className="input_label">Brand *</div>
                  <Select 
                    options={this.state.brands}  
                    value ={this.state.brand}
                    name = "brand"
                    className="district" 
                    ref={this.brandSelect}
                    onChange={e => this.brandChange(e)}
                    required
                  />   
                  <div className="influencer_feedback block">
				
        <table className="feedback_table">
          <thead>
            <tr>
              <td>Product</td>
              <td>ISI Type</td>
              <td>Quantity</td>
            </tr>
          </thead>
          <tbody className="categories_container">
            {this.state.products.map((item,idx) => (
              <tr className="single_category_container" key={idx}>
                <td className="category_name">{item.product_name}</td>
                <td>
                  <input className="category_id" type="hidden" name="products[]" value={item.id}/>
                  <Select 
                            name = "isi_type[]"
                            className="rate_us" 
                            options={options}
                            required
                  />  
                </td>
                <td>
                <input className="feedback" type="number" name="quantity[]"/>
                </td>
              </tr>
            ))}
          </tbody>
        </table>				
      </div>
            </div>
            <div className="product_details_container blocks" style={{display:this.state.analysis == 'OTHERS'?"block":"none"}}>
            <div className="customer_container">
              <div className="input_label_head">Others</div> 
            </div>
            <div className="input_label">Reason of Supporting Other Brand *</div>
            <textarea className="input billing_address custom_input" 
                name="reason"
                value={this.state.reason}
                onChange={this.formChange}
                autoComplete="off"
                required={(this.state.analysis == 'OTHERS')?true:false}
              /> 
                <div className="input_label">Contact Sphere *</div>
                  <Select 
                    options={this.state.contacts}  
                    value ={this.state.contact}
                    name = "contact"
                    className="district" 
                    ref={this.contactSelect}
                    onChange={e => this.contactChange(e)}
                    required
                  />  
                  <div className="input_label">Brands *</div>
                  <textarea className="input billing_address custom_input" 
                      name="other_brands"
                      value={this.state.other_brands}
                      onChange={this.formChange}
                      autoComplete="off"
                      required={(this.state.analysis == 'OTHERS')?true:false}
                    />  

                  <div className="input_label">Remarks *</div>
                  <textarea className="input billing_address custom_input" 
                      name="remarks"
                      value={this.state.remarks}
                      onChange={this.formChange}
                      autoComplete="off"
                      required={(this.state.analysis == 'OTHERS')?true:false}
                    />  
                      
            </div>
            <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
            </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default MarketingAnalysis;
MarketingAnalysis.contextType = MyContext;
